import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import { FaTimes } from "react-icons/fa";
import { Link } from "react-router-dom";

const CancelDialog = ({ open, toggleCancelDialog, cancelLink }) => {
  return (
    <div>
      <Dialog
        id="dialogBox"
        className="editeventpopup"
        open={open}
        onClose={toggleCancelDialog}
      >
        <DialogTitle>
          <div className="row">
            <div className="col-1 text-right ml-auto ">
              <FaTimes onClick={toggleCancelDialog} className="crossview cp" />
            </div>
          </div>
        </DialogTitle>
        <DialogContent>
          <div className="clear10"></div>
          <div className="row">
            <div className="col-12 text-center">
              <p className="fs-20 semi-bold text-center mb-4">
                Are you sure you want to cancel?
              </p>
              <div className="clear10"></div>
            </div>
          </div>
          <div className="row">
            <div className="col-5 col-md-5 col-lg-5 ml-auto mr-auto text-right mr-3">
              <button
                type="button"
                class="cancelbtn"
                onClick={toggleCancelDialog}
              >
                No
              </button>
            </div>
            <div className="col-5 col-md-5 col-lg-5 ml-auto mr-auto text-left mr-3">
              <Link to={cancelLink}>
                <button type="button" class="yes-btn">
                  Yes, Cancel
                </button>
              </Link>
            </div>
          </div>

          <div className="clear10"></div>

          <div className="clear10"></div>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default CancelDialog;
